// necessary set
import React from 'react'
import { observer } from 'mobx-react'

// need style
import '@pages/layout/layout.scss'

/**
 *
 * @author cardo
 *
 * @description
 * sto-admin-front: Loading
 * Loading
 */
const Loading: React.FC = observer(() => {
    return (
        <div className="loading-layer">
            <div className="donut"></div>
            {/* <div className="loading-img">
          <img src="./loading-img.gif" />
        </div> */}
        </div>
    )
})

export default Loading
